module.exports = __webpack_public_path__ + "img/co2.56c15c8.jpg";